module.exports = __webpack_public_path__ + "media/images/lb/613-6423cb09b4973f5c78796bc85393bffc.svg";